/**
 * Listjs search
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;
import List from 'list.js';

/**
 * Class ListSearch
 */
export default class ListSearch {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cached dom elements.
     */
    cache() {
    }

    /**
     * Event listeners.
     */
    events() {
    }

    listAction() {
        // Contact section
        const contactSection = $( '.search-list-section__contact' );

        if ( ! contactSection.length ) {
            return;
        }

        const options = {
            valueNames: [ 'search_keywords' ]
        };

        new List( 'office-list', options );

        // Contact Persons component listjs search
        new List( 'contact-persons', options );

        // Contact list searching
        // This is a little bit different than office search
        const contactList = new List( 'contact-list', options );

        // Show contact items when search field is updated
        contactList.on( 'updated', function( list ) {

            // Hide all elements if search field is empty so we will return to default state
            if ( ! list.searched ) {
                contactSection.addClass( 'u-hide' );
                list.items.forEach( function( item ) {
                    item.elm.classList.add( 'u-hide' );
                });
            } else {

                // Go through filtered items and remove 'u-hide' class from them
                if ( list.matchingItems.length > 0 ) {
                    contactSection.removeClass( 'u-hide' );
                    list.matchingItems.forEach( function( item ) {
                        item.elm.classList.remove( 'u-hide' );
                    });
                }
            }
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.listAction();
    }
}
